import { createFileRoute } from '@tanstack/react-router';

import { useSEO, useBreadcrumbSchema, PageSEO } from '../lib/seo';
import { LegalDocPage } from '../components/legal/LegalDocPage';
// Body extracted verbatim from sites/www/public/legal/intended-purpose/index.html (see privacy.tsx note).
import intendedPurposeBody from '../content/legal/intended-purpose.body.html?raw';

export const Route = createFileRoute('/legal/intended-purpose')({
  component: IntendedPurposePage,
});

function IntendedPurposePage() {
  useSEO(PageSEO.intendedPurpose);
  useBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Trust', url: '/trust' },
    { name: 'Intended Purpose Statement', url: '/legal/intended-purpose' },
  ]);

  return (
    <LegalDocPage
      title="Intended Purpose Statement"
      breadcrumbLabel="Intended Purpose Statement"
      metaLine="v1.0 · 27 April 2026"
      subtitle="What Neumind is, who it’s for, and how it sits within the UK regulatory framework for digital health products."
    >
      <div dangerouslySetInnerHTML={{ __html: intendedPurposeBody }} />
    </LegalDocPage>
  );
}
